import { createStyles, Grid, Theme, WithStyles, withStyles } from '@material-ui/core'
import React from 'react'
import DatePicker from '../../../components/DatePicker/DatePicker'

interface OutcomeDateItemProps extends WithStyles<typeof styles> {
	label: string
	prop: string
	value: any
	onDateChange: (e: any) => void
	required?: boolean
	topYear?: number
	maxDate?: string
	minDate?: string
	containerStyle?: object
  serviceType?: string
}

const OutcomeTextItem: React.FC<OutcomeDateItemProps> = (props: OutcomeDateItemProps) => {
	const { classes, onDateChange, label, maxDate, minDate, required, topYear, containerStyle } = props

	const [localDate, setDate] = React.useState(props.value)
	React.useEffect(() => {
      setDate(props.value);
	}, [props.value]);
	return (
		<div className={classes.root}>
			<Grid container={true} spacing={8} style={containerStyle}>
				<Grid item={true} xs={12} md={3} className={classes.label}>
					{label}&#58; { props.required === true && (<span className={classes.requiredField} >*</span> ) }
				</Grid>
				<Grid item={true} xs={12} md={9} style={{'padding': '4px 0'}}>
					<DatePicker
						label={label}
						onDateChange={onDateChange}
						hideLabel={true}
						required={required}
						topYear={topYear}
						noOfYears={5}
						date={localDate}
						maxDate={maxDate || ''}
						minDate={minDate || ''}
						rootStyle={{'flex-direction': 'row'}}
					/>
				</Grid>
			</Grid>
		</div>
	)
}

const styles = (theme: Theme) =>
	createStyles({
		root: {
			display: 'flex',
			flex: 1,
			alignItems: 'center',
			flexWrap: 'wrap',
			minHeight: '60px',
		},
		label: {
			justifyContent: 'flex-end',
			display: 'flex',
			paddingRight: '8px',
			alignItems: 'center',

			[theme.breakpoints.down('sm')]: {
				flexBasis: '100%',
				justifyContent: 'flex-start',
			},
		},
    requiredField:{
      color:'red'
    }
	})

export default withStyles(styles)(OutcomeTextItem)
